import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = {
  class: "menu menu-sub menu-sub-dropdown menu-column w-325px w-md-375px",
  "data-kt-menu": "true"
}
const _hoisted_2 = { class: "px-7 py-5" }
const _hoisted_3 = { class: "fs-5 text-dark fw-bolder" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "separator border-gray-200" }, null, -1)
const _hoisted_5 = { class: "px-7 py-5" }
const _hoisted_6 = { class: "row mb-8" }
const _hoisted_7 = { class: "col-6" }
const _hoisted_8 = { class: "col-6" }
const _hoisted_9 = ["placeholder"]
const _hoisted_10 = { class: "row mb-8" }
const _hoisted_11 = { class: "col-6" }
const _hoisted_12 = ["label"]
const _hoisted_13 = ["value"]
const _hoisted_14 = { class: "col-6" }
const _hoisted_15 = ["label"]
const _hoisted_16 = ["value"]
const _hoisted_17 = { class: "row mb-8" }
const _hoisted_18 = { class: "col-6" }
const _hoisted_19 = ["label"]
const _hoisted_20 = ["value"]
const _hoisted_21 = { class: "col-6" }
const _hoisted_22 = { class: "d-flex justify-content-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SearchField = _resolveComponent("SearchField")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.translate('Filter Options')), 1)
    ]),
    _hoisted_4,
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_SearchField, {
            modelValue: _ctx.selectedItems.horseId,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedItems.horseId) = $event)),
            options: _ctx.horseList,
            mode: "single",
            label: _ctx.translate('Select Horse'),
            className: "form-select-sm",
            trackBy: "nameEn"
          }, null, 8, ["modelValue", "options", "label"])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _withDirectives(_createElementVNode("input", {
            type: "number",
            name: "passportNumber",
            autocomplete: "off",
            class: "form-control form-control-sm form-control-solid",
            placeholder: _ctx.translate('Passport number'),
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedItems.passportNumber) = $event))
          }, null, 8, _hoisted_9), [
            [_vModelText, _ctx.selectedItems.passportNumber]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _withDirectives(_createElementVNode("select", {
            class: "form-select form-select-sm form-select-solid",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedItems.statusId) = $event))
          }, [
            _createElementVNode("option", {
              selected: "",
              label: _ctx.translate('Select Status'),
              value: "",
              disabled: ""
            }, null, 8, _hoisted_12),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statuses, (status) => {
              return (_openBlock(), _createElementBlock("option", {
                key: status.id,
                value: status.id
              }, _toDisplayString(status.nameEn), 9, _hoisted_13))
            }), 128))
          ], 512), [
            [_vModelSelect, _ctx.selectedItems.statusId]
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _withDirectives(_createElementVNode("select", {
            class: "form-select form-select-sm form-select-solid",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedItems.horseCategoryId) = $event))
          }, [
            _createElementVNode("option", {
              selected: "",
              label: _ctx.translate('Select Category'),
              value: "",
              disabled: ""
            }, null, 8, _hoisted_15),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categoryList, (category) => {
              return (_openBlock(), _createElementBlock("option", {
                key: category.id,
                value: category.id
              }, _toDisplayString(category.nameEn), 9, _hoisted_16))
            }), 128))
          ], 512), [
            [_vModelSelect, _ctx.selectedItems.horseCategoryId]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, [
          _withDirectives(_createElementVNode("select", {
            class: "form-select form-select-sm form-select-solid",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedItems.horseTypeId) = $event))
          }, [
            _createElementVNode("option", {
              selected: "",
              label: _ctx.translate('Select type'),
              value: "",
              disabled: ""
            }, null, 8, _hoisted_19),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.horseTypeList, (type) => {
              return (_openBlock(), _createElementBlock("option", {
                key: type.id,
                value: type.id
              }, _toDisplayString(type.nameEn), 9, _hoisted_20))
            }), 128))
          ], 512), [
            [_vModelSelect, _ctx.selectedItems.horseTypeId]
          ])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createVNode(_component_SearchField, {
            modelValue: _ctx.selectedItems.horseLocationId,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectedItems.horseLocationId) = $event)),
            options: _ctx.horseLocationList,
            mode: "single",
            label: _ctx.translate('Select Location'),
            className: "form-select-sm",
            trackBy: "nameEn"
          }, null, 8, ["modelValue", "options", "label"])
        ])
      ]),
      _createElementVNode("div", _hoisted_22, [
        _createElementVNode("button", {
          type: "reset",
          class: "btn btn-sm btn-white btn-active-light-primary me-2",
          "data-kt-menu-dismiss": "true",
          onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onReset && _ctx.onReset(...args)))
        }, _toDisplayString(_ctx.translate('reset')), 1),
        _createElementVNode("button", {
          type: "submit",
          class: "btn btn-sm btn-primary",
          "data-kt-menu-dismiss": "true",
          onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)))
        }, _toDisplayString(_ctx.translate('apply')), 1)
      ])
    ])
  ]))
}